module.exports = __webpack_public_path__ + "img/168.6b170c3a.jpg";